/**
 *
 * Created by Borbás Geri on 12/17/13
 * Copyright (c) 2013 eppz! development, LLC.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */

const ScrollTo = {
  /**
   * Helpers.
   */
  documentVerticalScrollPosition() {
    if (self.pageYOffset) return self.pageYOffset; // Firefox, Chrome, Opera, Safari.
    return 0; // None of the above.
  },

  viewportHeight() {
    return document.compatMode === 'CSS1Compat'
      ? document.documentElement.clientHeight
      : document.body.clientHeight;
  },

  documentHeight() {
    return document.height !== undefined
      ? document.height
      : document.body.offsetHeight;
  },

  documentMaximumScrollPosition() {
    return this.documentHeight() - this.viewportHeight();
  },

  elementVerticalClientPositionById(id) {
    var element = document.getElementById(id);
    var rectangle = element.getBoundingClientRect();
    return rectangle.top;
  },

  /**
   * Animation tick.
   */
  scrollVerticalTickToPosition(currentPosition, targetPosition) {
    var filter = 0.2;
    var fps = 60;
    var difference = parseFloat(targetPosition) - parseFloat(currentPosition);

    // Snap, then stop if arrived.
    var arrived = Math.abs(difference) <= 0.5;
    if (arrived) {
      // Apply target.
      scrollTo(0.0, targetPosition);
      return;
    }

    // Filtered position.
    currentPosition =
      parseFloat(currentPosition) * (1.0 - filter) +
      parseFloat(targetPosition) * filter;

    // Apply target.
    scrollTo(0.0, Math.round(currentPosition));

    // Schedule next tick.
    setTimeout(() => {
      ScrollTo.scrollVerticalTickToPosition(currentPosition, targetPosition);
    }, 1000 / fps);
  },

  /**
   * For public use.
   *
   * @param id The id of the element to scroll to.
   * @param padding Top padding to apply above element.
   */
  scrollVerticalToElementById(id, padding) {
    var element = document.getElementById(id);
    // TODO: Use strict equality checks and avoid reliance on coercion
    // eslint-disable-next-line eqeqeq
    if (element == null) {
      console.warn(`Cannot find element with id = ${id}`);
      return;
    }

    var targetPosition =
      this.documentVerticalScrollPosition() +
      this.elementVerticalClientPositionById(id) -
      padding;
    var currentPosition = this.documentVerticalScrollPosition();

    // Clamp.
    var maximumScrollPosition = this.documentMaximumScrollPosition();
    targetPosition = Math.min(targetPosition, maximumScrollPosition);

    // Start animation.
    this.scrollVerticalTickToPosition(currentPosition, targetPosition);
  },
};

export default ScrollTo;
